import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import EventMarkets from './event-markets.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays markets of an event.
 *
 * @class EventMarkets
 * @memberof Mojito.Modules
 */

/**
 * EventMarketsController prop types.
 *
 * @property {string} [eventId] - Id of the event to visualise.
 * @property {boolean} [hideMarketGroupSelector] - Hides the market group selector if set to true.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Modules.EventMarkets
 */
const propTypes = {
    eventId: PropTypes.string,
    hideMarketGroupSelector: PropTypes.bool,
    class: PropTypes.string,
};

export default UIView('EventMarkets', EventMarkets, propTypes);
